import './PublicSite.css';

export default function OurWork() {
  return (
    <div className="page our-work-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Work</h1>
          <p className="lead">Rehabilitation through love, patience, and regenerative systems</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="work-section">
            <div className="work-image" style={{
              backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/233c16bd-c6cb-4f72-9afd-f013a1c1f7cc/images/ba434004b4d132bf1eac5a4801066e0f5a34e5e9f463384d0357850e9d63addf.png')`
            }}></div>
            <div className="work-content">
              <h2>Animal Rehabilitation</h2>
              <p>
                We specialize in animals that other rescues turn away. Dogs labeled "aggressive," cats deemed "too feral," livestock with behavioral challenges—we take them all. Our approach is simple but revolutionary: <strong>patience over punishment, love over limitation</strong>.
              </p>
              <h3>Our Process</h3>
              <ul>
                <li><strong>Individual assessment:</strong> Every animal has unique trauma and needs</li>
                <li><strong>Off-grid environment:</strong> Low-stress, natural setting promotes healing</li>
                <li><strong>Integration training:</strong> Gradual exposure to children, other animals, adults</li>
                <li><strong>Behavior monitoring:</strong> 24/7 observation ensures safety and progress</li>
                <li><strong>Adoption readiness:</strong> Only when animal and adopter are truly compatible</li>
              </ul>
              <div className="stat-highlight">
                <div className="stat-number">100%</div>
                <div className="stat-label">Integration Success Rate</div>
              </div>
            </div>
          </div>

          <div className="work-section reverse">
            <div className="work-image" style={{
              backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/233c16bd-c6cb-4f72-9afd-f013a1c1f7cc/images/cc0bc0ed54caf180b003972a4a7a8a36a552aca356ee7d4f489d96501e60643d.png')`
            }}></div>
            <div className="work-content">
              <h2>Human Rehabilitation & Education</h2>
              <p>
                The sanctuary isn't just for animals. We provide education and healing for humans seeking:
              </p>
              <ul>
                <li><strong>Off-grid living skills:</strong> Water systems, solar power, sustainable food production</li>
                <li><strong>Holistic healing:</strong> Plant-based medicine, natural remedies, wellness practices</li>
                <li><strong>Animal care training:</strong> Learning compassionate, effective rehabilitation techniques</li>
                <li><strong>Self-sufficiency:</strong> Building resilience and independence from industrial systems</li>
              </ul>
              <p>
                We've helped individuals transition from urban homelessness to thriving off-grid lives. We've taught healing practices that reduce reliance on pharmaceuticals. And we've created a community where humans and animals heal together.
              </p>
            </div>
          </div>

          <div className="work-section">
            <div className="work-content full-width">
              <h2>Sustainable & Regenerative Operations</h2>
              <p>
                Our off-grid sanctuary demonstrates that compassion and sustainability are inseparable. We operate on principles that benefit all life:
              </p>
              <div className="sustainability-grid">
                <div className="sustainability-item">
                  <h4>💧 Water Systems</h4>
                  <p>3,500-gallon cistern with water recycling. Wastewater becomes garden irrigation—no chemicals, no waste.</p>
                </div>
                <div className="sustainability-item">
                  <h4>☀️ Solar Power</h4>
                  <p>Renewable energy systems (expanding). Off-grid operations ensure resilience and independence.</p>
                </div>
                <div className="sustainability-item">
                  <h4>🌾 Permaculture Integration</h4>
                  <p>Animals contribute to soil health. Gardens feed humans and animals. Regenerative cycles benefit all.</p>
                </div>
                <div className="sustainability-item">
                  <h4>🏡 Natural Building</h4>
                  <p>Rustic, low-impact structures that blend with the environment and minimize resource use.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Scaling Compassion</h2>
          <p>We've proven the model works. Now we're exploring innovative solutions—including robotics assistance—to scale this sanctuary model nationwide, creating a safety net for animals and humans across all 50 states.</p>
          <a href="/how-to-help" className="btn btn-primary btn-large">Help Us Grow</a>
        </div>
      </section>
    </div>
  );
}